import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const mentalHealthEvaluationsGlobalMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.MENTAL_HEALTH_EVALUATIONS_GLOBAL,
  iFrameSrcUrl: '/mental-health-evaluations-global',
  micrositeUrl: 'mental-health-evaluations-global',
  title: {
    id: 'mentalHealthEvaluationsGlobal.title',
    defaultMessage: 'Mental health leave support',
    description: 'Microsite page title for mental health leave support',
  },
  featureFlag: 'isMHEMicrositeFeatureEnabled',
  customerPropertyConditions: [{ key: 'isMHEToolkitEnabled', value: false }],
  postMessageEvents: [{ key: CMS_MICROSITE_MESSAGE_KEY.CONTACT_CARE_NAVIGATOR_BY_PHONE }],
  page: 'mental health evaluations global',
  trackUTMParams: {
    utm_campaign: 'mental-health-evaluations',
  },
  shouldHideForInternational: false,
  usePageForViewEvent: true,
}
